module.exports = __webpack_public_path__ + "media/images/app/loading-8e5097f77e401283899b509a5044dc0c.svg";